export const DEFAULT_TEXT_BLOCK_CLASS_NAME = 'text-block';

export const TEXT_BLOCK_PAGE_CONTENT_QUERY = {
  contentNodes: {
    content: true,
  },
};
